var map = {
	"./datei-ai.png": "c9e7",
	"./datei-doc.png": "b632",
	"./datei-docx.png": "0752",
	"./datei-eps.png": "cacb",
	"./datei-indd.png": "0fd1",
	"./datei-pdf.png": "8df9",
	"./datei-psd.png": "a9258",
	"./datei-tif.png": "35a0",
	"./datei-tiff.png": "45f3",
	"./datei-undefined.png": "1cc6",
	"./datei-xls.png": "685d",
	"./datei-xlsx.png": "7143",
	"./datei-zip.png": "7497"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a80";